// This file is AUTOGENERATED, do not edit it manually!!!

import { portfolios as portfoliosde } from './portfoliosResx.de';
import { portfolios as portfoliosen } from './portfoliosResx.en';
import { portfolios as portfoliosen_risk } from './portfoliosResx.en_risk';
import { portfolios as portfolioses } from './portfoliosResx.es';
import { portfolios as portfoliosfr } from './portfoliosResx.fr';
import { portfolios as portfoliosit } from './portfoliosResx.it';
import { portfolios as portfoliosnl } from './portfoliosResx.nl';
import { portfolios as portfoliospl } from './portfoliosResx.pl';
import { portfolios as portfoliospt } from './portfoliosResx.pt';
import { portfolios as portfoliosru } from './portfoliosResx.ru';
import { portfolios as portfoliossk } from './portfoliosResx.sk';
import { portfolios as portfoliossv } from './portfoliosResx.sv';
import { portfolios as portfoliostr } from './portfoliosResx.tr';

const langMap: { [k: string]: Partial<typeof portfoliosen> } = {
    de: portfoliosde,
    en: portfoliosen,
    en_risk: portfoliosen_risk,
    es: portfolioses,
    fr: portfoliosfr,
    it: portfoliosit,
    nl: portfoliosnl,
    pl: portfoliospl,
    pt: portfoliospt,
    ru: portfoliosru,
    sk: portfoliossk,
    sv: portfoliossv,
    tr: portfoliostr,
};

/* tslint:disable: max-line-length */
export const portfoliosResx = {
    get add_portfolio() {
        return langMap[ep.resxCulture].add_portfolio || langMap.en.add_portfolio;
    },
    get add_sub_portfolio() {
        return langMap[ep.resxCulture].add_sub_portfolio || langMap.en.add_sub_portfolio;
    },
    get copy_custom_fields_label() {
        return langMap[ep.resxCulture].copy_custom_fields_label || langMap.en.copy_custom_fields_label;
    },
    get delete_portfolio_title() {
        return langMap[ep.resxCulture].delete_portfolio_title || langMap.en.delete_portfolio_title;
    },
    get DeletionIsUsedDisabled() {
        return langMap[ep.resxCulture].DeletionIsUsedDisabled || langMap.en.DeletionIsUsedDisabled;
    },
    get Editor() {
        return langMap[ep.resxCulture].Editor || langMap.en.Editor;
    },
    get Manager() {
        return langMap[ep.resxCulture].Manager || langMap.en.Manager;
    },
    get members() {
        return langMap[ep.resxCulture].members || langMap.en.members;
    },
    get new_portfolio() {
        return langMap[ep.resxCulture].new_portfolio || langMap.en.new_portfolio;
    },
    get NewStatusTitle() {
        return langMap[ep.resxCulture].NewStatusTitle || langMap.en.NewStatusTitle;
    },
    get ParentPortfolio() {
        return langMap[ep.resxCulture].ParentPortfolio || langMap.en.ParentPortfolio;
    },
    get permissions_title() {
        return langMap[ep.resxCulture].permissions_title || langMap.en.permissions_title;
    },
    get Portfolios() {
        return langMap[ep.resxCulture].Portfolios || langMap.en.Portfolios;
    },
    get role_for_this_portfolio() {
        return langMap[ep.resxCulture].role_for_this_portfolio || langMap.en.role_for_this_portfolio;
    },
    get Statuses() {
        return langMap[ep.resxCulture].Statuses || langMap.en.Statuses;
    },
    get Teamer() {
        return langMap[ep.resxCulture].Teamer || langMap.en.Teamer;
    },
    get Viewer() {
        return langMap[ep.resxCulture].Viewer || langMap.en.Viewer;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.portfolios = portfoliosResx;
